import axios from "axios";

axios.defaults.withCredentials = false;
axios.defaults.crossDomain = true;

import * as qiniu from 'qiniu-js'
// let baseUrl = "";//process.env.VUE_APP_BASEURL;
let baseUrl = process.env.VUE_APP_BASEURL;

let RequestPlugin = {};

RequestPlugin.install = function(Vue, options) {
    //设置axios默认超时时间
    axios.defaults.timeout = 30000;

    /**
     * 普通上传
     * @param form
     */
    Vue.prototype.$upload = function(url, form, success, fail, error) {

        if (url.startsWith("http") == false) {
            url = baseUrl + url;
        }
        let formData = new FormData();
        Object.keys(form).forEach(k => {
            formData.append(k, form[k]);
        })
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': localStorage.getItem("token")
            }
        }
        let _this = this;
        return axios.post(url, formData, config).then(function(response) {

            var data = response.data;
            if (data.isTokenInvalid) { //token失效

                _this.$message.error({
                    message: '登录已失效，需要重新登录',
                    duration: 1000,
                    onClose: () => {
                        _this.$store.commit("reLogin");
                    }

                });

            } else if (data.success) {
                if (success) {
                    success(data);
                }
            } else if (data.success === false || data.success === "false") {
                if (fail) {
                    fail(data);
                } else {
                    _this.$message.error(data.msg ? data.msg : "发生异常，操作失败");
                }

            }

        }).catch(function(info) {
            if (error) {
                error(info);
            } else {
                console.debug(info);
                _this.$message.error("程序异常，操作失败");
            }
        })




    }

    /**
     * 上传到七牛
     * @param file
     * @param directory
     * @param options
     * @returns {Promise<unknown>}
     */
    Vue.prototype.$uploadQiniu = function(file, directory, options) {
        if (file == null) return;
        let baseurl, token;
        return this.$ajaxGet("/qiniu/config", (data) => {
            baseurl = data.result.baseurl;
            token = data.result.token;
        }).then(() => {
            if (directory.startsWith("/")) directory = directory.substring(1);
            if (directory.endsWith("/") == false && directory.length > 0) {
                directory += "/";
            }
            let path = directory;
            if (options && options.randomDirectory === false) { //不随机目录，用指定的directory作为目录的话
            } else {
                path += new Date().getTime() + "_" + Math.ceil(Math.random() * 1000) + "/";
            }
            //超哥说所有上传视频 ly_加filename
            let fileName = '';
            if (file.name.indexOf(".mp4") > 0) {
                fileName = "ly_" + file.name.substring(0, file.name.length - 4) + Math.ceil(Math
                    .random() * 1000) + ".mp4";
            } else {
                fileName = file.name;
            }
            path += fileName;
            let observable = qiniu.upload(file, path, token, {}, {});
            let fileBean = {
                name: fileName,
                url: "",
                percentage: 0,
                status: "uploading"
            };
            let observer = {
                next(res) {
                    fileBean.percentage = res.total.percent.toFixed(0);
                    if (options && options.going) {
                        fileBean.status = "uploading";
                        options.going(fileBean);
                    }
                },
                error(err) {
                    if (options && options.fail) {
                        options.fail(fileBean);
                    }
                },
                complete(res) {
                    fileBean.status = "success";
                    fileBean.url = baseurl + res.key;
                    if (options && options.success) {
                        options.success(fileBean);
                    }
                }
            }

            let subscription = observable.subscribe(observer) // 这样传参形式也可以

            fileBean.stop = () => {
                subscription.unsubscribe()
            };
            return new Promise((resolve) => {
                resolve(fileBean);
            })

        })
    }


    /**
     * 发起异步get请求
     * @param url
     * @param success 请求结果 success = true时的回调
     * @param fail 请求结果 success = false时的回调
     * @param error 请求异常时的回调
     * @param config axios配置项
     * @returns {Promise<AxiosResponse<any>>}
     */
    Vue.prototype.$ajaxGet = function(url, success, fail, error, config) {
        if (url.startsWith("http") == false) {
            url = baseUrl + url;
        }
        let _this = this;
        // let token = this.$store.state.token;
        //以localstorage为准，因为可能多个项目需要公用token
        let token = localStorage.getItem("token");

        let options = Object.assign({}, {
            method: 'get',
            url: url,
            headers: {
                "Authorization": token ? token : "", //每次都从localstorage中读取最新的token
                'X-Requested-With': 'XMLHttpRequest', //get请求需要自定义头，否则后台可能无法判断它是ajax请求
            }
        }, config)

        return axios(options).then(function(response) {

            var data = response.data;

            if (data.isTokenInvalid) {
                _this.$showError('登录已失效，需要重新登录', 1200, () => {
                    _this.$store.commit("reLogin");
                })


            } else if (data.success) {
                if (success) {
                    success(data);
                }
            } else if (data.success === false || data.success === "false") {
                if (fail) {
                    fail(data);
                } else {
                    _this.$showError(data.msg ? data.msg : "发生异常，操作失败");
                }

            }

        }).catch(function(info) {
            if (error) {
                error(info);
            } else {
                console.debug(info);
                _this.$showError("程序异常，操作失败");
            }
        })

    }

    /**
     * 发起异步post请求
     * @param url
     * @param data
     * @param success 请求结果 success = true时的回调
     * @param fail 请求结果 success = false时的回调
     * @param error 请求异常时的回调
     * @param config axios配置项
     * @returns {Promise<AxiosResponse<any>>}
     */
    Vue.prototype.$ajaxPost = function(url, params, success, fail, error, config) {
        if (url.startsWith("http") == false) {
            url = baseUrl + url;
        }
        let _this = this;
        // let token = this.$store.state.token;
        //以localstorage为准，因为可能多个项目需要公用token
        let token = localStorage.getItem("token");

        let options = Object.assign({}, {
            method: 'post',
            data: params,
            url: url,
            headers: {
                "Authorization": token ? token : "" //每次都从localstorage中读取最新的token
            }
        }, config)

        return axios(options).then(function(response) {

            var data = response.data;
            if (data.isTokenInvalid) { //token失效
                _this.$showError('登录已失效，需要重新登录', 1200, () => {
                    _this.$store.commit("reLogin");
                })

            } else if (data.success) {
                if (success) {
                    success(data);
                }
                //如果时分页查询，并且不是第一页，并且本次一个数据也没查到，就触发上一页
                if (params.pager && params.pager.currentPage > 1 && (!data.result || !data.result
                        .length) && _this.pageChange) {

                    _this.pageChange(params.pager.currentPage - 1);
                }
            } else if (data.success === false || data.success === "false") {
                if (fail) {
                    fail(data);
                } else {
                    _this.$showError(data.msg ? data.msg : "发生异常，操作失败");
                }

            }

        }).catch(function(info) {
            if (error) {
                error(info);
            } else {
                console.debug(info);
                _this.$showError("程序异常，操作失败");
            }
        })

    }





    /**
     * 获取 scratch的访问地址，可能是七牛，可能是本地服务器上的
     * 这个函数一定是登录后，才被调用的
     * @returns {Promise<unknown>}
     */
    function getScratchUrl(_this) {
        return new Promise(resolve => {

            resolve("/scratch");

            //如果开发环境
            // if (process.env.NODE_ENV == "development") {
            //     resolve(process.env.VUE_APP_SCRATCH_URL);
            //     return;
            // }
            //
            // let scratchUrl = localStorage.getItem("scratchUrl");
            // if (scratchUrl) {
            //     resolve(scratchUrl);
            //     return;
            // }
            // let msg = _this.$showInfo("Scratch页面即将打开，请留意新标签页...", 5000);
            //
            // //获取 检测本地服务器是否可用的时间，看这个时间是否超过5s，因为检测的超时时间是5s
            // let checkLocalTime = localStorage.getItem("checkLocalTime");
            // checkLocalTime = checkLocalTime ? Number(checkLocalTime) : null;
            // //必须等 本地服务器检测完成后，才可以去后台获取scratch访问地址
            // let waitTime = checkLocalTime ? (5000-(new Date().getTime() - checkLocalTime)) : 5000;
            //
            // setTimeout(() => {
            //     _this.$ajaxGet("/config/getScratchUrl", data => {
            //         msg.close();
            //         scratchUrl = data.result;
            //         localStorage.setItem("scratchUrl", scratchUrl);
            //
            //         resolve(scratchUrl);
            //     })
            // }, waitTime)




        })
    }
    Vue.prototype.$goEditCode = function(lessonType, args) {
        switch (lessonType) {
            case 1: //scratch
                this.$goScratch(args);
                break;
            case 2: //python
                this.$goPython(args);
                break;
            case 3: //c++
                this.$goCpp(args);
                break;
            case 4: //jr
                if (args) {
                    args += "&jr=";
                } else {
                    args = "jr=";
                }
                this.$goScratch(args);
                break;
        }

    }
    /**
     * 使用a标签模拟打开Scratch
     * @param args
     */
    Vue.prototype.$goScratch = function(args) {
        let _this = this;
        //1. 检测是否登录了，只有登录了，才可以进入Scratch
        if (!window.getLocalToken()) {
            _this.$showError('登录已失效，需要重新登录', 1200, () => {
                _this.$store.commit("reLogin");
            })
            return;
        }

        //2. 获取可使用的地址
        getScratchUrl(_this).then(url => {
            console.debug("scratch url:", url);
            //
            // let lastTime = localStorage.getItem("tokenUpdateTime");
            // url += "?h=" + window.location.host + "&t=" + window.getLocalToken() + "&tt=" + lastTime;
            // if (args) {
            //     url += "&" + args;
            // }
            if (args) {
                url += "?" + args;
            }
            window.openTab(url);
        })
    }
    Vue.prototype.$goPython = function(args) {
        let _this = this;
        //1. 检测是否登录了，只有登录了，才可以进入Scratch
        if (!window.getLocalToken()) {
            _this.$showError('登录已失效，需要重新登录', 1200, () => {
                _this.$store.commit("reLogin");
            })
            return;
        }

        //2. 获取可使用的地址
        let url = "/python/";
        if (args) {
            url += "?" + args;
        }
        window.openTab(url);
    }
    Vue.prototype.$goCpp = function(args) {
        let _this = this;
        //1. 检测是否登录了，只有登录了，才可以进入Scratch
        if (!window.getLocalToken()) {
            _this.$showError('登录已失效，需要重新登录', 1200, () => {
                _this.$store.commit("reLogin");
            })
            return;
        }

        //2. 获取可使用的地址
        let url = "/c_pp/";
        if (args) {
            url += "?" + args;
        }
        window.openTab(url);
    }


}

export default RequestPlugin;
